import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../Firebase/Config";
import Loading from "../../Loading/Loading";

function Skill() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    const ref = collection(db, "about");
    getDocs(ref).then((snapshot) => {
      if (snapshot.empty) {
        setError("خطایی رخ داد");
        setLoading(false);
      } else {
        setLoading(false);
        let result = [];
        snapshot.docs.forEach((doc) => {
          result.push({ id: doc.id, ...doc.data() });
        });
        setData(result);
      }
    });
  }, []);

  return (
    <div className="xl:w-3/6 pt-16 sm:w-full">
      <h3 className="mb-5 text-custom_black">مهارت ها</h3>
      {error ? (
        <p className="text-black">{error}</p>
      ) : loading ? (
        <Loading />
      ) : data ? (
        <div className="flex flex-wrap text-white">
          {data
            .sort((a, b) => a.Id - b.Id)
            .map((item) => (
              <div className="w-full" key={item.Id}>
                <p className="font-extralight mb-2 text-custom_pink">
                  {item.Title}
                </p>
                <div className="rounded-lg border p-1 mb-5">
                  <div
                    style={{
                      width: `${item.Size}%`,
                      backgroundImage:
                        "linear-gradient(83deg, purple 0%, orange 100%)",
                      padding: "4px",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              </div>
            ))}
        </div>
      ) : (
        <p className="text-black">داده‌ای وجود ندارد</p>
      )}
    </div>
  );
}

export default Skill;